import * as types from './types';
import { set } from 'lodash';
import { createContactsData } from '../models/contacts-data.model';
import { createContactDetails } from '../models/contact-details.model';
import { contactGroupMutations } from './groups/mutations';
import { contactFileMutations } from './files/mutations';
import { implementSetAllNavTabDetailsMutation } from '../../../dt-plugins/sidewindow/nav-tab';

export const mutations = {
  [types.ContactsData.SET.ALL](state, payload) {
    state.contactsData = createContactsData(payload);
  },
  // [types.SET_CONTACT_LIST_STARTROW] (state, payload) {
  //   state.contactListStartRow = payload;
  // },
  [types.SelectedContact.SET.SINGLE](state, payload) {
    state.selectedContact = createContactDetails(payload);
  },
  [types.SelectedContactLoading.SET.SINGLE](state, payload) {
    state.selectedContactLoading = payload;
  },
  [types.SelectedContactGroups.DELETE.SINGLE]({ selectedContact = createContactDetails() }, payload) {
    selectedContact.related_groups = selectedContact.related_groups.filter(g => {
      if (g.group_id == payload.group_id) {
        return false;
      } else {
        return true;
      }
    })
  },
  [types.SelectedContactGroups.SET.ALL](state, payload) {
    state.selectedContact.related_groups = payload;
  },
  [types.SelectedContact.UPDATE.SINGLE](state, payload) {
    const { name, value } = payload;
    state.selectedContact = createContactDetails({
      ...state.selectedContact,
      contact: {
        ...state.selectedContact.contact,
        [name]: value
      }
    });
  },
  [types.SelectedContactRelatedContacts.SET.ALL](state, payload) {
    state.selectedContact.contact_relations = payload;
  },
  [types.SelectedContactRelatedContacts.UPDATE.SINGLE](state, payload) {
    const { name, value, item } = payload;
    state.selectedContact.contact_relations = selectedContact.contact_relations.map(cr => {
      if (cr.contact_id == item.contact_id) {
        return {
          ...cr,
          [name]: value
        };
      } else {
        return cr;
      }
    });
  },
  [types.SelectedContactRelatedContacts.DELETE.SINGLE](state, payload) {
    state.selectedContact.contact_relations = selectedContact.contact_relations.filter(cr => {
      if (cr.contact_id == payload.contact_id) {
        return false;
      } else {
        return true;
      }
    })
  },
  // [types.SET_CONTACT_FILES](state, payload) {
  //   state.selectedContact.files = payload;
  // },
  [types.ContactFiles.DELETE.SINGLE](state, payload) {
    const { file_id, file_relation_id } = payload;
    state.selectedContact.files = state.selectedContact.files.filter(file => {
      if (file.file_id === file_id && file.file_relation_id === file_relation_id) {
        return false;
      } else {
        return true;
      }
    });
  },
  [types.ContactFields.SET.ALL](state, payload) {
    state.selectedContact.fields = payload;
  },
  [types.ContactAccountingInfo.SET.ALL](state, payload) {
    state.accountingInfo = payload;
  },

  [types.SET_CONTACT_SEARCH_CONFIG](state, payload) {
    state.searchConfig = payload;
  },
  ...implementSetAllNavTabDetailsMutation(types.ContactDetails, 'contactDetails'),


  ...contactGroupMutations,
  ...contactFileMutations,
}